import ENV from "@/utils/env";
import { api } from "@/lib/api";
import { Recommendation } from "@/api/copilot/types/recommendation.type.";

/*
 * getAttentionRecommendation endpoint
 *
 * Attention recommendation is for a specific attention metric (visibility, clarity, digestibility).
 * This can be a lengthy process as it is run through claudes AI.
 */
export const getAttentionRecommendation = async (projectId: string, studyId: string, key: string, metric: string, type?: string) => {
  const typeParam = type ? `&type=${type}` : "";
  const resp = await api.get(`${ENV.API_PLATFORM_URL}/pipeline/copilot/images/v1/attention/${metric}?prefix=${projectId}/${studyId}&key=${key}${typeParam}`);
  return resp.data.data as Recommendation;
};

/*
 * getMemoryRecommendation endpoint
 *
 * Recommendation for memory insights.
 * This can be a lengthy process as it is run through claudes AI.
 */
export const getMemoryRecommendation = async (projectId: string, studyId: string, key: string) => {
  const resp = await api.get(`${ENV.API_PLATFORM_URL}/pipeline/copilot/images/v1/memory?prefix=${projectId}/${studyId}&key=${key}`);
  return resp.data.data as Recommendation;
};

/*
 * getEmotionRecommendation endpoint
 *
 * Recommendation for emotion insights.
 * This can be a lengthy process as it is run through claudes AI.
 */
export const getEmotionRecommendation = async (projectId: string, studyId: string, key: string) => {
  const resp = await api.get(`${ENV.API_PLATFORM_URL}/pipeline/copilot/images/v1/emotion?prefix=${projectId}/${studyId}&key=${key}`);
  return resp.data.data as Recommendation;
};
